import {
	observer
} from 'mobx-react';
import {
	WeaDialog
} from "ecCom";

@observer
export default class Dialog extends React.Component {
	render() {
		const {
			store
		} = this.props, {
			dialogProps,
			title,
			style,
			visible,
			buttons,
			moreBtn={},
			closeDialog
		} = store;

		return (
			<WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@moy7y3`}
			  {...dialogProps}
	          title={title}
	          style={style}
	          visible={visible}
	          buttons={buttons}
	          moreBtn={moreBtn}
	          onCancel={closeDialog}
        	>
        	    {this.props.children}
        	</WeaDialog>
		)
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/valhalla/components/Dialog.js